import { render } from "./UseAsMemberButton.vue?vue&type=template&id=e06c5cac"
import script from "./UseAsMemberButton.vue?vue&type=script&lang=js"
export * from "./UseAsMemberButton.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3809301774/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__